import { GapDensityMapThemeContext } from "@app/projects/network-assessment/maps/gap-density-map/contexts/GapDensityMapThemeContext";
import { GAP_DENSITY_MAP_STYLE } from "@app/projects/network-assessment/maps/gap-density-map/GapDensityMapsConstants";
import { GapDensityMapTheme } from "@app/projects/network-assessment/maps/gap-density-map/interfaces"
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";
import { ModalLink } from "@app/shared/Modals";
import { QESButton } from "@app/shared/qes-standards/Button";
import { FC, useContext } from "react";

type GapDensityMapThemeComponentProps = {
  theme: GapDensityMapTheme;
}

export const GapDensityMapThemeComponent: FC<GapDensityMapThemeComponentProps> = ({ theme }) => {

  const themeContext = useContext(GapDensityMapThemeContext);

  return (
    <>
      <div className="gap-density-map__theme-component-container">
        <div
          className="gap-density-map__theme-component"
        >
          {theme.name}
          <div className="gap-density-map__theme-colors">
            {
              [theme.noGapColor, theme.gapColor1, theme.gapColor2, theme.gapColor3, theme.gapColor4]
                .map((color, idx) =>
                  <div
                    key={`${theme.name}-${idx}`}
                    style={{
                      backgroundColor: color,
                      border: GAP_DENSITY_MAP_STYLE.GAP_DENSITY_MAP_THEME_COLOR_CIRCLE_BORDER,
                      borderRadius: "50%",
                      height: GAP_DENSITY_MAP_STYLE.GAP_DENSITY_MAP_THEME_COLOR_CIRCLE_DIAMETER,
                      width: GAP_DENSITY_MAP_STYLE.GAP_DENSITY_MAP_THEME_COLOR_CIRCLE_DIAMETER,
                    }}
                  />
                )
            }
          </div>
        </div>
        <QESButton
          qesTestId={`gap-density-map__theme-component-edit-${theme.name}`}
          qesType="secondary"
          onClick={() => {
            themeContext.setThemeToEdit(theme);
            themeContext.setEditingBucketIndex(null);
          }}
        >
          <div className="gap-density-map__theme-edit-button-content">
            <QesIcon iconName={QesIcons.PencilV1} isDecorative />
            Edit
          </div>
        </QESButton>
        <ModalLink
          content={{
            body: "Are you sure you want to delete this theme? This action cannot be undone.",
            cancelButtonText: "Cancel",
            confirmButtonAction: () => themeContext.deleteCustomTheme(theme),
            confirmButtonText: "Delete",
            confirmButtonType: "primary-danger",
            title: `Delete ${theme.name}`,
          }}
          testId={`gap-density-map__theme-component-delete-${theme.name}`}
          classNames="qes-button-secondary danger"
          hideBodyScroll={true}
        >
          Delete
        </ModalLink>
      </div>
    </>
  )
}